import './App.css';
import Footer from './MainFunctions/Footer';
import Header from './MainFunctions/Header';
import MainApp from './MainApp';
import { MantineProvider } from '@mantine/core';
import InstallApp from './MainFunctions/InstallApp';
import Banner from './Components/Banner';

function App() {
  setTimeout(() => {
    window.location.reload();
  }, 30 * 60 * 1000); // 30 minutes

  return (
    <MantineProvider theme={{ colorScheme: 'dark' }} withGlobalStyles withNormalizeCSS>
      <Header />
      <MainApp />
      <hr />
      <InstallApp />
      <Footer />
      <Banner />
    </MantineProvider>

  );
}

export default App;
